var image = $('#main-image img'),
    thumbnails = $('#product-image-gallery a'),
    link = image.parent();

image.smoothZoom({
    zoominSpeed: 800,
    zoomoutSpeed: 400,
    zoominEasing: 'swing',
    zoomoutEasing: 'swing',
    navigationButtons: 'false',
    closeButton: 'true',
    showCaption: 'false'
});

image.on('click', function(e){
   var parent = $(this).closest('#main-image');

   if(parent && parent.hasClass('invalid-zoom')) {
       e.preventDefault();
       e.stopPropagation();
       return;
   } 
});

// set overflow for <body> to freeze "scroll page" feature
link.on('click', function(e){

    var parent = $(this).closest('#main-image');

    if(parent && parent.hasClass('invalid-zoom')) {
        e.preventDefault();
        e.stopPropagation();
        return;
    }

    var $body = $('body');

    $body.addClass('no-scroll');

    // disable 'bounce' effect in IOS devices
    document.ontouchmove = function(e){ e.preventDefault() };
    // clean overflow state
    $(document).on('click.bq.productImage', '.sz-overlay, .sz-zoomed, .sz-close', function(){

        $body.removeClass('no-scroll');
        $(document).off('click.bq.productImage');
        // enable 'bounce' effect in IOS devices
        document.ontouchmove = null;
    });
});

thumbnails.on('click', function(e) {

    var el = $(this),
        thumbnailImage = el.children('img[data-bq="image-load"]').size()
            ? el.children('img[data-bq="image-load"]').first()
            : null;

    if (thumbnailImage) {
        image.attr('alt', thumbnailImage.attr('alt'));
        image.attr('title', thumbnailImage.attr('title'));

        if ($.inArray(thumbnailImage.data('imageType'), ['product', 'supplier']) !== -1) {
            image.on('error', function(e) {
                var placeholderUrl;

                if (thumbnailImage.data('supplierId')) {
                    placeholderUrl = bq.global.imageHelper.getSupplierImage(thumbnailImage);
                } else {
                    placeholderUrl = bq.global.imageHelper.getSupplierPlaceholderImage();
                }

                $(e.target).attr('src', placeholderUrl);
                link.attr('href', placeholderUrl);
            });
        }
    }

    link.attr('href', el.data('imageBig'));
    image.attr('src', el.data('image'));
    thumbnails.removeClass('active');
    el.addClass('active');
});
